'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = deprecate;
function deprecate(message, fn) {
  return function () {
    if (process.env.NODE_ENV !== 'production') console.warn('Deprecation: ' + message);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return fn.call.apply(fn, [this].concat(args));
  };
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/utils/deprecate.js
// module id = 1339
// module chunks = 32